class PrelaunchCountdownTimer extends CountdownTimer {
  ended() {
    // remove class
    let mainProduct = document.querySelector('.product--isPrelaunchProduct');
    if (mainProduct) {
      mainProduct.classList.remove('product--isPrelaunchProduct');
    }

    // remove product-group local storage item
    localStorage.removeItem('product-group');
  }
}

customElements.define('prelaunch-countdown-timer', PrelaunchCountdownTimer);

class Prelaunch extends HTMLElement {
  constructor() {
    super();
  }

  convertDate(date) {
    // convert to date GMT-4
    date = new Date(date);
    date = date.toLocaleString('en-US', { timeZone: 'America/New_York' });
    return new Date(date);
  }

  hasExpired(end_date) {
    // check if expired
    const now = new Date();
    return end_date < now;
  }
}

class PrelaunchBadge extends Prelaunch {
  constructor() {
    super();
  }

  connectedCallback() {
    this.end_date = this.convertDate(this.dataset.endDate);
    // check if blank
    if (!this.end_date) {
      console.log('No end date provided');
      return;
    }

    // check if expired
    if (this.hasExpired(this.end_date)) {
      this.remove();
      return;
    }

    // set timer
    this.setTimer();
  }

  setTimer() {
    // check every second if the end date has passed, if so remove the badge and stop the timer

    let timer = setInterval(() => {
      if (this.hasExpired(this.end_date)) {
        this.remove();
        clearInterval(timer);
      }
    }, 1000);
  }
}

window.customElements.define('prelaunch-badge', PrelaunchBadge);
